import proj4 from "proj4";

const POISERVERNAME = process.env.REACT_APP_POI_SERVER_NAME;
const POIPLUSAPP = process.env.REACT_APP_POI_PLUS_APP;

export const searchAddressEtc = (searchWord) => {
  if (searchWord?.length > 100) {
    //100文字より多い場合は処理しない
    console.log(searchWord.length);
  } else {
    return Promise.all([
      // 駅
      fetch(
        [
          POISERVERNAME,
          `devkit/station/service.asmx/GetFromVarious?app=${POIPLUSAPP}`,
          `&keyword=${encodeURI(searchWord)}`,
          "&genreID=&addressCode=&orderby=&offset=&limit=10&option=",
        ].join("")
      )
        .then(function (response1) {
          return response1.text().then(function (response_text) {
            return geojsonFrom(response_text).features;
          });
        })
        .catch((err) => {
          console.log(err);
        }),
      // 住所
      fetch(
        [
          POISERVERNAME,
          `devkit/address/service.asmx/GetFromAddress?app=${POIPLUSAPP}`,
          `&address=${encodeURI(searchWord)}`,
          "&code=&orderby=&offset=&limit=10&option=",
        ].join("")
      )
        .then(function (response1) {
          return response1.text().then(function (response_text) {
            return geojsonFrom(response_text).features;
          });
        })
        .catch((err) => {
          console.log(err);
        }),
      // 目標物
      fetch(
        [
          POISERVERNAME,
          `devkit/landmark/service.asmx/GetFromVarious?app=${POIPLUSAPP}`,
          `&keyword=${encodeURI(searchWord)}`,
          "&genreID=&addressCode=&orderby=&offset=&limit=10&option=",
        ].join("")
      )
        .then(function (response1) {
          return response1.text().then(function (response_text) {
            return geojsonFrom(response_text).features;
          });
        })
        .catch((err) => {
          console.log(err);
        }),
    ])
      .then(function (featuress) {
        const features = featuress.reduce(function (a, e) {
          return a.concat(e);
        }, []);
        if (features.length > 0) {
          return features
            .map((feature) => {
              if (!feature) {
                return null;
              }
              var str_station_label = feature.properties.railway
                ? feature.properties.name + "駅 " + feature.properties.railway
                : null;
              var str_station_value = feature.properties.railway
                ? feature.properties.name + "駅"
                : null;

              var str_address_label =
                feature.properties.matchLevel === "1"
                  ? feature.properties.pref
                  : feature.properties.matchLevel === "2"
                  ? feature.properties.city
                  : feature.properties.matchLevel === "3"
                  ? feature.properties.city + " " + feature.properties.town1
                  : feature.properties.matchLevel === "4"
                  ? feature.properties.city +
                    " " +
                    feature.properties.town1 +
                    feature.properties.town2
                  : feature.properties.matchLevel <= 6
                  ? feature.properties.city +
                    " " +
                    feature.properties.town1 +
                    feature.properties.town2 +
                    feature.properties.address
                  : feature.properties.city +
                    " " +
                    feature.properties.town1 +
                    feature.properties.town2 +
                    feature.properties.block1 +
                    "－" +
                    feature.properties.address;
              var str_address_value =
                feature.properties.matchLevel === "1"
                  ? feature.properties.pref
                  : feature.properties.matchLevel === "2"
                  ? feature.properties.city
                  : feature.properties.matchLevel === "3"
                  ? feature.properties.city + feature.properties.town1
                  : feature.properties.matchLevel === "4"
                  ? feature.properties.city +
                    feature.properties.town1 +
                    feature.properties.town2
                  : feature.properties.matchLevel <= 6
                  ? feature.properties.city +
                    feature.properties.town1 +
                    feature.properties.town2 +
                    feature.properties.address
                  : feature.properties.city +
                    feature.properties.town1 +
                    feature.properties.town2 +
                    feature.properties.block1 +
                    "－" +
                    feature.properties.address;
              var str_category =
                str_station_label != null
                  ? "【駅】"
                  : feature.properties.matchLevel >= 1
                  ? "【地名】"
                  : "【目標物】";
              return {
                label:
                  str_station_label ||
                  feature.properties.name ||
                  str_address_label ||
                  "",
                value:
                  str_station_value ||
                  feature.properties.name ||
                  str_address_value ||
                  "",
                category: str_category,
                X: feature.geometry.coordinates[0],
                Y: feature.geometry.coordinates[1],
              };
            })
            .filter(Boolean);
        } else {
          return [];
        }
      })
      .catch((error) => console.error("Promise All error:", error));
  }
};

proj4.defs(
  "EPSG:4301",
  "+proj=longlat +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +no_defs"
);
const geojsonFrom = (responseXml) => {
  if (!responseXml) {
    return {};
  }

  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(responseXml, "application/xml");

  // エラーチェック
  const status = xmlDoc.querySelector("status");
  if (!status || status.textContent !== "0") {
    console.error("APIエラー", responseXml);
    return {};
  }

  // オブジェクト変換
  const elements = xmlDoc.querySelectorAll(
    "AddressElement,StationElement,LandmarkElement"
  );
  const objects = Array.from(elements).map((item) => {
    const keys = [
      "name",
      "railway",
      "matchLevel",
      "pref",
      "city",
      "town1",
      "town2",
      "block1",
      "address",
      "x",
      "y",
    ];
    const retItem = keys.reduce((accumulator, key) => {
      accumulator[key] = item.querySelector(key)?.textContent || "";
      return accumulator;
    }, {});
    return retItem;
  });
  const features = objects.map((e) => {
    const lonlat = proj4(proj4.defs["EPSG:4301"], proj4.defs["EPSG:4326"], {
      x: Number(e.x) / 3600,
      y: Number(e.y) / 3600,
    });
    delete e.x;
    delete e.y;
    return {
      type: "Feature",
      properties: e,
      geometry: { type: "Point", coordinates: [lonlat.x, lonlat.y] },
    };
  });
  return { type: "FeatureCollection", features: features };
};
